import { render, staticRenderFns } from "./document-download.vue?vue&type=template&id=e7c44c0c&"
import script from "./document-download.vue?vue&type=script&lang=js&"
export * from "./document-download.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7c44c0c')) {
      api.createRecord('e7c44c0c', component.options)
    } else {
      api.reload('e7c44c0c', component.options)
    }
    module.hot.accept("./document-download.vue?vue&type=template&id=e7c44c0c&", function () {
      api.rerender('e7c44c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/document-download.vue"
export default component.exports